import Vue from "vue";

import _ from "lodash";

import { Component, Prop, Watch } from "@/decorators";

import "./searchComboMultiSelect.scss";

@Component
export default class SearchComboMultiSelectComponent extends Vue {
    selected: any[] = [];
    searchText = "";
    options: any[] = [];
    loading = false;
    hasSearched = false;
    noOptionsMessage = "";

    debouncedSearch = _.debounce(this.performSearch.bind(this), 400);

    @Prop({ required: true }) service!: any;
    @Prop({ default: "Buscar..." }) placeholder!: string;
    @Prop({ default: false }) disabled!: boolean;
    @Prop({ default: 3 }) minSearchLength!: number;
    @Prop({ default: 15 }) pageSize!: number;
    @Prop({ default: "nome" }) searchField!: string;
    @Prop({ type: Array, default: () => [] }) defaultValue!: any[];
    @Prop(Array) value!: any[];

    @Watch("selected")
    private onSelectedChanged() {
        this.$emit("input", this.selected);
        this.$emit("change", this.selected);
    }

    @Watch("value")
    private onValueChange() {
        this.syncValue();
    }

    @Watch("defaultValue")
    private onDefaultValueChanged() {
        this.syncValue();
    }

    private syncValue() {
        const source = this.value || this.defaultValue || [];

        if (!Array.isArray(source)) {
            this.selected = [];
            return;
        }

        const newSelected = source.map(v => {
            if (typeof v === "object" && v !== null && v.value !== undefined) {
                return v;
            }
            return { value: v, text: `ID: ${v}` };
        });

        const changed = JSON.stringify(this.selected) !== JSON.stringify(newSelected);
        if (changed) {
            this.selected = newSelected;
        }
    }

    private async performSearch() {
        if (!this.service) return;

        this.loading = true;
        this.hasSearched = true;

        try {
            const response = await this.service.listCliente(
                this.searchText || "",
                this.searchField,
                "asc",
                1,
                this.pageSize,
                "",
                "",
            );

            const data = await response.json();

            this.options = (data.list || []).map((item: any) => ({
                value: item.id,
                text: item.razaoSocial || item.nome || item.nomeFantasia || item.descricao || String(item.id),
                raw: item,
            }));

            this.noOptionsMessage = "Nenhum resultado encontrado";
            this.loading = false;
            this.hasSearched = false;
        } catch {}
    }

    private onOpen() {
        if (this.searchText.length < this.minSearchLength) {
            this.noOptionsMessage = `Digite pelo menos ${this.minSearchLength} caracteres para buscar`;
            return;
        }

        if (this.options.length === 0 && !this.hasSearched) {
            this.searchText = "";
            this.performSearch();
        }
    }

    private onClose() {}

    private onRemove(selectedItem: any) {
        this.selected = this.selected.filter(s => s.value !== selectedItem.value);
    }

    private onSearchChange(newSearch: string) {
        this.searchText = newSearch;
        if (this.searchText.length >= this.minSearchLength) {
            this.noOptionsMessage = "Nenhum resultado encontrado";
            this.debouncedSearch();
        } else {
            this.options = [];
            this.hasSearched = false;
            this.noOptionsMessage = `Digite pelo menos ${this.minSearchLength} caracteres para buscar`;
        }
    }

    private mounted() {
        this.syncValue();
        this.noOptionsMessage = `Digite pelo menos ${this.minSearchLength} caracteres para buscar`;
    }
}
